<template>
	<authorization permissionKey="attendance_surgery" can="read">
		<v-container fluid>
			<v-row>
				<v-col class="text-h3 gray--text">
					Movimentação do Paciente
				</v-col>
			</v-row>

			<PatientTime :attendanceId="attendanceId" />
		</v-container>
	</authorization>
</template>

<script>
import PatientTime from "@/components/queues/attendance/patient_time.vue";

export default {
	name: "PatientIndex",
	components: {
		PatientTime,
	},
	data() {
		return {
			attendanceId: String,
		};
	},
	created() {
		if (this.$route.params.attendance_id) {
			this.attendanceId = this.$route.params.attendance_id;
		}
	},
}

</script>
